<template>
  <!-- 聚能谷微信用户关联费空表 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker v-model="filter.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
          end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-edit" type="primary" @click="toFeetableInitByHand"
          v-permision_tjtf="'bind_by_hand'">人工绑定</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-descriptions :column="4" :border="true" style="margin-bottom: 20px;">
      <el-descriptions-item label="总初装费： ">
        <span class="bold ssuc">{{ 0.00 }}元</span>
      </el-descriptions-item>
      <el-descriptions-item></el-descriptions-item>
      <el-descriptions-item></el-descriptions-item>
      <el-descriptions-item></el-descriptions-item>
    </el-descriptions> -->

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="所属分支箱" prop="branch_box_name" align="center"></el-table-column>
      <el-table-column label="分支箱资产码" prop="assets_code" align="center"></el-table-column>
      <el-table-column label="电表地址" prop="feetable_address" width="120" align="center"></el-table-column>
      <el-table-column label="通道" prop="gun_no" width="60" align="center"></el-table-column>
      <el-table-column label="初装费" prop="init_fee" width="80" align="center"></el-table-column>
      <el-table-column label="枪号" prop="EBDNumber" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="手机号" prop="phone" width="110" align="center"></el-table-column>
      <!-- <el-table-column label="停车位" prop="park_no" width="80" align="center"></el-table-column> -->
      <el-table-column label="微信昵称" prop="wx_nick_name" width="110" align="center"></el-table-column>
      <el-table-column label="状态" prop="is_use" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.del" type="info">已解绑</el-tag>
          <el-tag v-else-if="!row.del && row.is_use" type="success">正常</el-tag>
          <el-tag v-else type="danger">停用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" width="150" prop="create_time" align="center"></el-table-column>

      <el-table-column :label="$t('publics.operation')" align="center" width="120">
        <template slot-scope="{ row }">
          <el-button type="text" v-if="!row.del" @click="onUnBind(row)" v-permision_tjtf="'unbind'">解绑</el-button>
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <div class="statistic_left">
        <span class="sbox">
          总初装费：<span class="bold sinfo"> {{ dataStaticInfo.totalInitFee }}元</span>
        </span>
      </div>
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="详情" width="800px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
          <el-col :span="12">
            <!-- <el-form-item label="ID" prop="ID">
              <el-input v-model="detailForm.ID" readonly disabled />
            </el-form-item> -->
            <el-form-item label="费控表编号" prop="fee_table_id">
              <el-input v-model="detailForm.fee_table_id" readonly disabled />
            </el-form-item>
            <el-form-item label="车牌号" prop="car_no">
              <el-input v-model="detailForm.car_no" readonly disabled />
            </el-form-item>
            <el-form-item label="停车位" prop="park_no">
              <el-input v-model="detailForm.park_no" readonly disabled />
            </el-form-item>
            <!-- <el-form-item label="union_id" prop="union_id">
              <el-input v-model="detailForm.union_id" readonly disabled />
            </el-form-item> -->
            <el-form-item label="微信昵称" prop="wx_nick_name">
              <el-input v-model="detailForm.wx_nick_name" readonly disabled />
            </el-form-item>
            <el-form-item label="费控表地址" prop="fee_table_address">
              <el-input v-model="detailForm.fee_table_address" readonly disabled />
            </el-form-item>
            <el-form-item label="状态" prop="del">
              <el-tag v-if="detailForm.del" type="info">已解绑</el-tag>
              <el-tag v-else-if="!detailForm.del && detailForm.is_use" type="success">正常</el-tag>
              <el-tag v-else type="danger">停用</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="枪号" prop="EBDNumber">
              <el-input v-model="detailForm.EBDNumber" readonly disabled />
            </el-form-item>
            <el-form-item label="微信订单号" prop="wx_order_no">
              <el-input v-model="detailForm.wx_order_no" readonly disabled />
            </el-form-item>
            <el-form-item label="聚能谷订单号" prop="jng_order_no">
              <el-input v-model="detailForm.jng_order_no" readonly disabled />
            </el-form-item>
            <el-form-item label="支付金额" prop="init_fee">
              <el-input v-model="detailForm.init_fee" readonly disabled />
            </el-form-item>
            <el-form-item label="创建时间" prop="create_time">
              <el-input v-model="detailForm.create_time" readonly disabled />
            </el-form-item>
            <el-form-item label="修改时间" prop="modify_time">
              <el-input v-model="detailForm.modify_time" readonly disabled />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
    <FeetableInitByHand ref="feetableInitByHand"></FeetableInitByHand>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { GetFeeTableInitPageList, UnBindPoleAndFeetableForBack, getFeeTableInitStatisticInfoApi } from "@/api/dev_fee_table"
import FeetableInitByHand from "./components/_feetable_init_by_hand.vue"
import { mapGetters } from "vuex"
export default {
  name: "JngWxuserAndFeetable",
  components: { FeetableInitByHand },
  mixins: [pageMixin],
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      tableData: [],
      filter: {
        assets_code: "",
        car_no: "",
        dateRange: [], // 使用一个数组来同时存储开始和结束时间
        union_id: ""
      },
      loading: false,
      dataStaticInfo: { totalInitFee: 0 },
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    toFeetableInitByHand() {
      this.$refs["feetableInitByHand"].showBindByHand()
    },
    onUnBind(row) {
      this.$confirm("确定要解除设备和费控表的绑定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          UnBindPoleAndFeetableForBack({ jng_wxuser_and_feetable_id: row.ID })
            .then((res) => {
              this.$message.success(res.msg)
              this.toFilter()
            })
            .catch((error) => {
              this.$message.error("处理失败")
            })
        })
        .catch(() => { })
    },
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },
    getData() {
      this.loading = true
      this.getFeeTableInitStatisticInfo();
      GetFeeTableInitPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        start_time: (!this.filter.dateRange || this.filter.dateRange.length == 0) ? "" : this.filter.dateRange[0],
        end_time: (!this.filter.dateRange || this.filter.dateRange.length == 0) ? "" : this.filter.dateRange[1],
        car_no: this.filter.car_no || null,
        union_id: this.filter.union_id || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    getFeeTableInitStatisticInfo() {
      getFeeTableInitStatisticInfoApi({
        assets_code: this.filter.assets_code || null,
        start_time: (!this.filter.dateRange || this.filter.dateRange.length == 0) ? "" : this.filter.dateRange[0],
        end_time: (!this.filter.dateRange || this.filter.dateRange.length == 0) ? "" : this.filter.dateRange[1],
        car_no: this.filter.car_no || null,
        union_id: this.filter.union_id || null
      })
      .then((res) => {
        //console.log(res)
        this.dataStaticInfo = res
      })
      .finally(() => {

      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
